import React, { useState, useEffect } from 'react';

import { CheckCircle, AlertCircle } from 'lucide-react';

import { useTranslation } from 'react-i18next';

import { useProcesses, useProcessMutations } from '../../../hooks/useProcesses';

import { usePolicyFrameworks } from '../../../hooks/usePolicyFrameworks';

import { useNotifications } from '../../NotificationSystem';

import './SetupWizardSteps.css';



const Step6ProcessRegistry = ({ stepData, onComplete, onValidation, userData, userName, structure }) => {

  const { notify } = useNotifications();

  const { t } = useTranslation(['setup', 'nomenclatures']);

  const [loading, setLoading] = useState(false);

  const organizationId = structure?.organizations?.[0]?.id || null;

  const { processes, loading: processesLoading } = useProcesses(organizationId);

  const { frameworks } = usePolicyFrameworks(organizationId);

  const { createProcess } = useProcessMutations();



  useEffect(() => {

    if (processes && processes.length >= 3) {

      onComplete({ processes: processes.length, requirementsMet: true });

    }

  }, [processes]);



  const handleCreateBasicProcesses = async () => {

    if (!organizationId) {

      notify.error(t('step6.notifications.missingOrganization'), t('step6.notifications.missingOrganizationTitle'));

      return;

    }



    if (!frameworks || frameworks.length === 0) {

      notify.error(t('step6.notifications.missingFramework'), t('step6.notifications.missingFrameworkTitle'));

      return;

    }



    setLoading(true);

    try {

      const frameworkId = frameworks[0].id;

      const processCategory = t('nomenclatures:process_categories.QUALITY');

      const defaultSection = t('step6.defaultSection');

      const basicProcesses = [

        {

          processCode: 'EXAMPLE-001',

          processName: t('step6.defaultProcesses.example1.processName'),

          processCategory,

          section: defaultSection,

          subsection: 'EXAMPLE-001',

          description: t('step6.defaultProcesses.example1.description'),

          objective: t('step6.defaultProcesses.example1.objective'),

          scope: 'Hospital-wide',

          policyFrameworkId: frameworkId,

          isIPCRelevant: false,

          organizationId

        },

        {

          processCode: 'EXAMPLE-002',

          processName: t('step6.defaultProcesses.example2.processName'),

          processCategory,

          section: defaultSection,

          subsection: 'EXAMPLE-002',

          description: t('step6.defaultProcesses.example2.description'),

          objective: t('step6.defaultProcesses.example2.objective'),

          scope: 'Hospital-wide',

          policyFrameworkId: frameworkId,

          isIPCRelevant: false,

          organizationId

        },

        {

          processCode: 'EXAMPLE-003',

          processName: t('step6.defaultProcesses.example3.processName'),

          processCategory,

          section: defaultSection,

          subsection: 'EXAMPLE-003',

          description: t('step6.defaultProcesses.example3.description'),

          objective: t('step6.defaultProcesses.example3.objective'),

          scope: 'Hospital-wide',

          policyFrameworkId: frameworkId,

          isIPCRelevant: false,

          organizationId

        }

      ];



      for (const process of basicProcesses) {

        await createProcess(process, userData?.uid || 'system', userName || 'System');

      }



      notify.success(t('step6.notifications.createdSuccess'), t('step6.notifications.createdSuccessTitle'));

      onComplete({ processes: 3, requirementsMet: true });

    } catch (error) {

      console.error('Error creating processes:', error);

      notify.error(t('step6.notifications.createFailed'), t('step6.notifications.createFailedTitle'));

    } finally {

      setLoading(false);

    }

  };



  const requirements = {

    processes: (processes || []).length >= 3

  };



  return (

    <div className="step-content">

      <div className="step-section">

        <h3>{t('step6.title')}</h3>

        <p>{t('step6.description')}</p>

      </div>



      {!organizationId && (

        <div className="error-message" style={{ marginBottom: '20px', padding: '12px', backgroundColor: '#fff3cd', color: '#856404', borderRadius: '6px' }}>

          {t('step6.completeStep1Warning')}

        </div>

      )}



      {(!frameworks || frameworks.length === 0) && (

        <div className="error-message" style={{ marginBottom: '20px', padding: '12px', backgroundColor: '#fff3cd', color: '#856404', borderRadius: '6px' }}>

          {t('step6.completeStep5Warning')}

        </div>

      )}



      <div className="quick-setup-section">

        <div className="quick-setup-option" style={{ cursor: loading || !organizationId || !frameworks || frameworks.length === 0 ? 'not-allowed' : 'pointer', opacity: loading || !organizationId || !frameworks || frameworks.length === 0 ? 0.6 : 1 }}>

          <div style={{ textAlign: 'center' }}>

            <h3>{t('step6.quickSetupTitle')}</h3>

            <p>{t('step6.quickSetupDescription')}</p>

            <button

              type="button"

              className="btn btn-primary"

              onClick={handleCreateBasicProcesses}

              disabled={loading || !organizationId || !frameworks || frameworks.length === 0}

              style={{ marginTop: '16px' }}

            >

              {loading ? t('step6.creating') : t('step6.createBasicProcesses')}

            </button>

          </div>

        </div>

      </div>



      <div className="requirements-section" style={{ marginTop: '32px' }}>

        <h3>{t('step6.processesTitle')}</h3>

        <div className="requirements-list">

          <div className={`requirement-item ${requirements.processes ? 'met' : 'pending'}`}>

            {requirements.processes ? <CheckCircle size={20} color="#4caf50" /> : <AlertCircle size={20} color="#ff9800" />}

            <span>{t('step6.processesCount', { count: (processes || []).length })}</span>

          </div>

        </div>



        {requirements.processes && (

          <div className="success-message" style={{ marginTop: '20px' }}>

            {t('step6.minimumMet')}

          </div>

        )}

      </div>

    </div>

  );

};



export default Step6ProcessRegistry;

